// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TchPqzvosxskAhmavPUc{flex-direction:column;gap:24px;padding-top:2px;padding-bottom:3px;display:flex}.TchPqzvosxskAhmavPUc.ZXDTSvOUweY2quGTJbat{padding:13px 20px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `TchPqzvosxskAhmavPUc`,
	"booking": `ZXDTSvOUweY2quGTJbat`
};
export default ___CSS_LOADER_EXPORT___;
